import { useQuery } from '@tanstack/react-query'
import { memberCountryService } from '@/lib/api/services/member-country'
import type { PaginationParams, MemberCountryFilterParams } from '@/lib/api/types'

// Query keys factory
export const memberCountryKeys = {
  all: ['memberCountries'] as const,
  lists: () => [...memberCountryKeys.all, 'list'] as const,
  list: (params: PaginationParams, filters: MemberCountryFilterParams) =>
    [...memberCountryKeys.lists(), params, filters] as const,
  byRegion: (regionTag: string, params: PaginationParams) =>
    [...memberCountryKeys.all, 'region', regionTag, params] as const,
}

/**
 * Hook to fetch paginated countries with filters
 */
export const useMemberCountries = (
  params: PaginationParams = { page: 1, size: 100 },
  filters: MemberCountryFilterParams = {},
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: memberCountryKeys.list(params, filters),
    queryFn: () => memberCountryService.getMemberCountries(params, filters),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

/**
 * Hook to fetch countries by region tag
 */
export const useMemberCountriesByRegion = (
  regionTag: string,
  params: PaginationParams = { page: 1, size: 100 }
) => {
  return useQuery({
    queryKey: memberCountryKeys.byRegion(regionTag, params),
    queryFn: () => memberCountryService.getMemberCountriesByRegion(regionTag, params),
    enabled: !!regionTag,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

/**
 * Hook to fetch all member countries (no pagination)
 */

export const useAllMemberCountries = () => {
  return useQuery({
    queryKey: memberCountryKeys.all,
    queryFn: () => memberCountryService.getAllMemberCountries(),
    staleTime: 10 * 60 * 1000, // 10 minutes
  })
}


